import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useState } from "react";
import { FaCalendarDay, FaUserAlt } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { PermissionDTO } from "../profil.model.ts";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { getUserById } from "@core/actions/usersActions.ts";
import { loadingUserDetails, userDetails } from "@core/slice/UsersSlice.ts";
import Spinner from "@shared/Spinner.tsx";
import { formatDate } from "@utils/appUtils.ts";

const DetailUser: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params = useParams();
  const userId = params.id;
  const userDetail = useAppSelector(userDetails);
  const loading = useAppSelector(loadingUserDetails);
  const [activeIndex, setActiveIndex] = useState(0);


  React.useEffect(() => {
    if (userId) {
      dispatch(getUserById(userId));
    }
  }, [dispatch, userId]);

  function handlePrevious() {
    navigate("/setting/list-user");
  }
  return (
    <div className="w-full column gap-5 bg-white rounded-lg py-8">
      {/* Titre dynamique basé sur l'onglet actif */}
      <div className="text-2xl font-semibold text-black ml-8">
        {activeIndex === 0
          ? "Information sur le compte utilisateur"
          : "Historique d'action utilisateur"}
      </div>
      <div className="ml-3 mr-3">
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header="DÉTAIL">
            {loading === "loading" ? (
              <div className="flex justify-center py-4">
                <Spinner />
              </div>
            ) : (
              <>
                {userDetail && (
                  <div className="flex flex-col sm:flex-row rounded-lg bg-[#E5E5E5] w-full gap-6 p-6">
                    {/* Bloc gauche */}
                    <div className="flex flex-col bg-white md:w-1/2 w-full rounded-lg p-6 gap-3">
                      <div className="text-black font-semibold">
                        Information sur l'utilisateur ID n°:{" "}
                        {userDetail.id}
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Nom:{" "}
                        </span>
                        <span className="text-gray-900">
                          {userDetail.lastName}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Prénom(s):
                        </span>
                        <span className="text-gray-900">
                          {userDetail.firstName}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Email personnel:
                        </span>
                        <span className="text-gray-900">
                          {userDetail.email}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Télephone:
                        </span>
                        <span className="text-gray-900">
                          {userDetail.telephone}
                        </span>
                      </div>
                    </div>

                    {/* Bloc droit */}
                    <div className="flex flex-col bg-white md:w-1/2 w-full rounded-lg p-6 gap-3">
                      <div className="text-black font-semibold">
                        Information sur le compte:
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Email utilisateur:
                        </span>
                        <span className="text-gray-900">
                          {userDetail.email}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Accès utilisateur:
                        </span>
                        <span className="text-gray-900">
                          {userDetail.profil?.permissions
                            ?.map((item: PermissionDTO) => item.name)
                            .join(", ") || ""}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Rôles:{" "}
                        </span>
                        <span className="text-gray-900">
                          {userDetail.profil.name}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Date d'inscription:
                        </span>
                        <span className="text-gray-900">
                          {formatDate(userDetail.createdAt)}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500 font-semibold">
                          Mot de passe:{" "}
                        </span>
                        <span className="text-gray-900">****</span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Bouton Retour */}
            <div className="flex justify-end mt-12">
              <Button
                className="justify-center w-[120px] bg-[#64748B] text-white font-bold py-2 px-4 rounded-md gap-2"
                onClick={handlePrevious}
              >
                Retour
              </Button>
            </div>
          </TabPanel>
          <TabPanel header="HISTORIQUE">
            <div className="w-full border border-gray-200 shadow px-6 py-3 rounded-lg gap-2">
              <div className="text-black font-semibold">
                Enregistrement de plaintes N°
              </div>
              <div className="flex gap-3">
                <div className="flex gap-2 justify-center items-center">
                  <FaCalendarDay />
                  <span>06/11/2024</span>
                </div>

                <div className="flex gap-2 justify-center items-center">
                  <FaUserAlt />
                  <span>User</span>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-12">
              <Button
                className="justify-center w-[120px] bg-[#64748B] text-white font-bold py-2 px-4 rounded-md gap-2"
                onClick={handlePrevious}
              >
                Retour
              </Button>
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default DetailUser;
